/**
 * Pure validation functions for the scorecard creation form.
 * Extracted from views/create/index.tsx for testability.
 */

export function validPhoneNumber(phoneNumber: string): boolean {
  if (!phoneNumber.trim()) {
    return false;
  }
  return phoneNumber.trim().length >= 10 && phoneNumber.trim().length <= 15;
}

export function validEmail(email: string): boolean {
  if (!email.trim()) {
    return false;
  }
  return email.trim().includes('@');
}

export function invalidContact(params: {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}): boolean {
  const { firstName, lastName, email, phoneNumber } = params;
  if (
    !firstName.trim() ||
    !lastName.trim() ||
    !validEmail(email) ||
    !validPhoneNumber(phoneNumber)
  ) {
    return true;
  }
  return false;
}

export function anyContact(params: {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  title: string;
}): boolean {
  const { firstName, lastName, email, phoneNumber, title } = params;
  return !!(
    firstName.trim() ||
    lastName.trim() ||
    email.trim() ||
    phoneNumber.trim() ||
    title.trim()
  );
}
